import { BJumbotron } from './jumbotron';
import { pluginFactory } from '../../utils/plugins';
var JumbotronPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BJumbotron: BJumbotron
  }
});
export { JumbotronPlugin, BJumbotron };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/jumbotron/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/jumbotron/index.js
// module chunks = 1